import { Calendar } from "primereact/calendar";
import { addLocale } from "primereact/api";
function EditableCalendar(props) {
  const { formData, setFormData } = props;
  addLocale("pt", {
    firstDayOfWeek: 1,
    dayNames: ["Domingo", "Segunda-Feira", "Ter\xE7a-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "S\xE1bado"],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "S\xE1b"],
    dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
    monthNames: ["Janeiro", "Fevereiro", "Mar\xE7o", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
    today: "Hoje",
    clear: "Limpar"
  });
  const handleDateChange = (e) => {
    setFormData((prev) => ({ ...prev, time_expiration: e.value }));
  };
  return (
      <Calendar
          id="calendar-24h"
          value={formData.time_expiration}
          onChange={handleDateChange}
          showTime
          hourFormat="24"
          showIcon
          className="rounded"
          locale="pt"
      />
  );
}
export {
  EditableCalendar
};